/*
 * @Author: Jame Jame@novax.email
 * @Date: 2025-12-24 20:12:26
 * @LastEditors: Jame Jame@novax.email
 * @LastEditTime: 2025-12-29 16:29:10
 * @FilePath: /github_p2p/src/utils/baseUrl.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
let urls = {
    baseUrl: '',
    socketUrl: '',
    staticState: '',
    linkUrl: '',
    threePartyUrl: ''
}; //这里是一个默认的url，可以没有
const hostArr = window.location.host.split('.')
var url = ''
if (hostArr.length == 3) {
    hostArr[0] = ''
    url = hostArr.join('.')
} else {
    url = '.' + hostArr.join('.')
}
switch (process.env.NODE_ENV) {
    case 'development': // 开发环境
        urls.baseUrl = "https://test-api.superex.bike"
        urls.socketUrl = 'wss://test-api.superex.bike/socket/ws'
        // urls.baseUrl = "https://nova-api.nova-x.ca"
        // urls.socketUrl = 'wss://nova-api.nova-x.ca/socket/ws'
        urls.staticState = 'https://static.spex.ltd'
        urls.linkUrl = 'http://localhost:8989'
        urls.nowUrl = 'http://' + window.location.host
        urls.threePartyUrl = 'https://pay.superex.bike'
        break
    case 'test': // 开发测试环境
        urls.baseUrl = "https://nova-api.nova-x.ca"
        urls.socketUrl = 'wss://nova-api.nova-x.ca/socket/ws'
        urls.staticState = 'https://static.spex.ltd'
        urls.linkUrl = 'https://dev.nova-x.ca'
        urls.nowUrl = 'https://' + window.location.host
        urls.threePartyUrl = 'https://pay.superex.bike'
        break
    case 'tests': // 测试站
        urls.baseUrl = "https://test-api.superex.bike"
        urls.socketUrl = 'wss://test-api.superex.bike/socket/ws'
        urls.staticState = 'https://static.spex.ltd'
        urls.linkUrl = 'https://www.superex.bike'
        urls.nowUrl = 'https://' + window.location.host
        urls.threePartyUrl = 'https://pay.superex.bike'
        break
    case 'production': //生产环境
        urls.baseUrl = 'https://api.superexchang.com'
        urls.socketUrl = 'wss://api.superexchang.com/socket/ws'
        urls.staticState = 'https://static.spex.ltd'
        urls.linkUrl = 'https://www' + url
        urls.nowUrl = 'https://' + window.location.host
        urls.threePartyUrl = 'https://pay.superex.com'
        break
}

export default urls;
